


























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import KmyChatTagText from '@/components/parts/KmyChatTagText.vue';
import * as api from '@/api/api';
import Enumerable from 'linq';
import NotificationService from '@/services/notificationservice';
import EventObjectWithParam from '../../models/common/EventObjectWithParam';

@Component({
  components: {
    KmyChatTagText,
  },
})
export default class IssueBbs extends Vue {
  @Prop() public account!: api.Account;
  @Prop() public mutes!: api.Mute[];
  @Prop() public isAdministrator!: boolean;
  @Prop() public onNewThreadReceived!: EventObjectWithParam<api.IssueBbsItem>;
  private isUpdating: boolean = false;
  private isNeedUpdatePage: boolean = false;
  private newThread: api.IssueBbsItem = new api.IssueBbsItem(-1);
  private threads: api.IssueBbsItem[] = [];
  private currentThread: api.IssueBbsItem[] = [];
  private currentThreadReply: string = '';
  private page = 1;
  private filteringMilestone = 0;
  private filteringStatus = 0;
  private filteringKeyword = '';
  private isOpenMilestonePopup = false;
  private isOpenStatusPopup = false;
  private isOpenNewThreadForm = false;
  private canNextPage = false;
  private navigateStack: number[] = [];
  private isStatusPopupOpen = false;
  private isCategoryPopupOpen = false;
  private isMilestonePopupOpen = false;

  private get currentThreadReversed(): api.IssueBbsItem[] {
    return this.currentThread.slice().reverse();
  }

  private created() {
    this.loadPage(1);
    this.onNewThreadReceived.onFire = (thread) => {
      if (this.currentThread.length > 0) {
        if (this.currentThread[0].id === thread.parentId) {
          this.currentThread.push(thread);
        }
        if (this.currentThread[0].id === thread.id) {
          Vue.set(this.currentThread, 0, thread);
        }
      }

      let isNotNeedUpdate = false;
      this.threads.forEach((t) => {
        if (t.id === thread.id) {
          t.status = thread.status;
          t.category = thread.category;
          t.period = thread.period;
          t.betaVersion = thread.betaVersion;
          isNotNeedUpdate = true;
        }
        if (t.id === thread.parentId) {
          t.lastModified = thread.lastModified;
          t.lastWriterAccountName = thread.accountName;
        }
      });

      if (!isNotNeedUpdate) {
        this.isNeedUpdatePage = true;
      }
    };
  }

  private isReported(item: api.IssueBbsItem): boolean {
    return this.mutes.some((m) => m.issueBbsItemId === item.id && m.type === api.Mute.typeReported);
  }

  private reportMessage(item: api.IssueBbsItem, status: boolean) {
    this.isUpdating = true;
    api.Api.reportIssueBbsItem(status ? api.Mute.typeReported : api.Mute.typeNone, item.id)
      .then(() => {
        NotificationService.reported.notify();
      })
      .catch(() => NotificationService.reportFailed.notify())
      .finally(() => this.isUpdating = false);
  }

  private toggleReportOpen(obj: api.IssueBbsItem) {
    const a = obj as any as { isOpenReports: boolean };
    Vue.set(a, 'isOpenReports', !a.isOpenReports);
  }

  private loadPage(num: number) {
    this.isUpdating = true;
    api.Api.getIssuePage(num - 1, this.filteringMilestone, this.filteringStatus, this.filteringKeyword)
      .then((items) => {
        this.threads = items;
        this.page = num;
        if (this.page === 1) {
          this.isNeedUpdatePage = false;
        }
        this.canNextPage = this.threads.length >= 20;
      })
      .catch(() => {
        NotificationService.loadThreadFailed.notify();
      })
      .finally(() => this.isUpdating = false);
  }

  private openIssue(id: number) {
    if (this.currentThread.length > 0) {
      if (this.currentThread[0].id !== id) {
        this.navigateStack.push(this.currentThread[0].id);
        this.loadThread(id);
      }
    } else {
      this.loadThread(id);
    }
  }

  private backIssue() {
    if (this.navigateStack.length > 0) {
      const id = this.navigateStack.pop() as number;
      this.loadThread(id);
    }
  }

  private loadThread(id: number) {
    this.isUpdating = true;
    api.Api.getIssue(id)
      .then((items) => {
        this.currentThread = items;
        this.currentThreadReply = '';
      })
      .catch(() => {
        NotificationService.loadThreadFailed.notify();
      })
      .finally(() => {
        this.isUpdating = false;
      });
  }

  private write(thread: api.IssueBbsItem) {
    this.isUpdating = true;
    api.Api.postIssue(0, thread.title, thread.text)
      .then((th) => {
        NotificationService.writeThreadSucceed.notify();
        this.isOpenNewThreadForm = false;
        this.loadThread(th.id);
      })
      .catch(() => {
        NotificationService.writeThreadFailed.notify();
      })
      .finally(() => {
        this.isUpdating = false;
        thread.title = '';
        thread.text = '';
      });
  }

  private writeThread(parentThread: api.IssueBbsItem, text: string) {
    this.isUpdating = true;
    api.Api.postIssue(parentThread.id, '', text)
      .then(() => {
        NotificationService.writeThreadSucceed.notify();
      })
      .catch(() => {
        NotificationService.writeThreadFailed.notify();
      })
      .finally(() => {
        this.isUpdating = false;
        this.currentThreadReply = '';
      });
  }

  private getThreadStatus(val: number) {
    return val === api.IssueBbsItem.statusNew ? '新規' :
      val === api.IssueBbsItem.statusDiscussing ? '議論中' :
      val === api.IssueBbsItem.statusInReady ? '採用' :
      val === api.IssueBbsItem.statusWaiting ? '実装待ち' :
      val === api.IssueBbsItem.statusProcessing ? '実装中' :
      val === api.IssueBbsItem.statusCompleted ? '完了' :
      val === api.IssueBbsItem.statusRejected ? '却下' :
      val === api.IssueBbsItem.statusDuplicate ? '重複' :
      val === api.IssueBbsItem.statusComposite ? '複合' :
      val === api.IssueBbsItem.statusInvalid ? '無効' :
      val === api.IssueBbsItem.statusWontfix ? '対応せず' :
      val === api.IssueBbsItem.statusPending ? '保留' : '不明';
  }

  private toggleStatusPopupOpen() {
    this.isStatusPopupOpen = !this.isStatusPopupOpen;
  }

  private updateThreadStatus(item: api.IssueBbsItem, val: number) {
    this.isUpdating = true;
    api.Api.updateThreadProperty(item.id, val, item.category, 0)
      .then(() => {
        item.status = val;
        NotificationService.threadPropertyChanged.notify();
      })
      .catch(() => {
        NotificationService.threadPropertyChangeFailed.notify();
      })
      .finally(() => this.isUpdating = false);
  }

  private toggleMilestonePopupOpen() {
    this.isMilestonePopupOpen = !this.isMilestonePopupOpen;
  }

  private updateThreadMilestone(item: api.IssueBbsItem, val: number) {
    this.isUpdating = true;
    api.Api.updateThreadProperty(item.id, item.status, item.category, val)
      .then(() => {
        NotificationService.threadPropertyChanged.notify();
      })
      .catch(() => {
        NotificationService.threadPropertyChangeFailed.notify();
      })
      .finally(() => this.isUpdating = false);
  }

  private getThreadCategory(val: number) {
    return val === api.IssueBbsItem.categoryNew ? '確認中' :
      val === api.IssueBbsItem.categoryEnhancement ? '開発' :
      val === api.IssueBbsItem.categoryBug ? 'バグ' :
      val === api.IssueBbsItem.categoryRule ? 'ルール' :
      val === api.IssueBbsItem.categoryOther ? 'その他' : '不明';
  }

  private toggleCategoryPopupOpen() {
    this.isCategoryPopupOpen = !this.isCategoryPopupOpen;
  }

  private updateThreadCategory(item: api.IssueBbsItem, val: number) {
    this.isUpdating = true;
    api.Api.updateThreadProperty(item.id, item.status, val, 0)
      .then(() => {
        item.category = val;
        NotificationService.threadPropertyChanged.notify();
      })
      .catch(() => {
        NotificationService.threadPropertyChangeFailed.notify();
      })
      .finally(() => this.isUpdating = false);
  }
}
